import React, { useState } from "react";

import { applyFormatToSelectedRange, applyStyleToSelectedRange, applyLinkToSelectedRange, removeLinkFromSelectedRange, LinkPopover } from "../../RichTextEditor";
import Button from "../../Shared/UI/Button/components/Button";
import BoldIcon from '../../Shared/UI/BoldIcon/components/BoldIcon';
import CitationsSectionIcon from '../../Shared/UI/CitationsSectionIcon/components/CitationsSectionIcon';
import EmphasisIcon from '../../Shared/UI/EmphasisIcon/components/EmphasisIcon';
import ItalicIcon from '../../Shared/UI/ItalicIcon/components/ItalicIcon';
import LargeSectionTitleIcon from '../../Shared/UI/LargeSectionTitleIcon/components/LargeSectionTitleIcon';
import LinkIcon from '../../Shared/UI/LinkIcon/components/LinkIcon';
import SmallSectionTitleIcon from '../../Shared/UI/SmallSectionTitleIcon/components/SmallSectionTitleIcon';
import SubtitleIcon from '../../Shared/UI/SubtitleIcon/components/SubtitleIcon';
import SuperscriptIcon from '../../Shared/UI/SuperscriptIcon/components/SuperscriptIcon';
import TitleizeIcon from '../../Shared/UI/TitleizeIcon/components/TitleizeIcon';

import styles from './EventDescription.module.scss';

const EventDescriptionFormattingControls = ({ contentEditable, setState, activeStyleTypes = [], activeFormat, activeHref, editableContentId }) => {
  const [linkPopoverOpen, setLinkPopoverOpen] = useState(false);

  return (
    <>
      {contentEditable && (
        <div className={styles.stylingTool}>
          <Button
            variant="secondary"
            icon={<BoldIcon />}
            iconOnly
            aria-label="Bold"
            pressed={activeStyleTypes.includes('b')}
            onClick={() => applyStyleToSelectedRange({ style: { type: 'b' }, setState })}
          />
          <Button
            variant="secondary"
            icon={<ItalicIcon />}
            iconOnly
            aria-label="Italic"
            pressed={activeStyleTypes.includes('i')}
            onClick={() => applyStyleToSelectedRange({ style: { type: 'i' }, setState })}
          />
          <LinkPopover
            isOpen={linkPopoverOpen}
            onClose={() => setLinkPopoverOpen(false)}
            onApply={(href) => {
              setLinkPopoverOpen(false);
              applyLinkToSelectedRange({ href, setState, editableContentId });
            }}
            onRemove={() => {
              setLinkPopoverOpen(false);
              removeLinkFromSelectedRange({ setState, editableContentId });
            }}
            initialHref={activeHref}
          >
            <Button
              variant="secondary"
              icon={<LinkIcon />}
              iconOnly
              aria-label="Link"
              pressed={activeStyleTypes.includes('a')}
              onClick={() => setLinkPopoverOpen(!linkPopoverOpen)}
            />
          </LinkPopover>
          <Button
            variant="secondary"
            icon={<TitleizeIcon />}
            iconOnly
            aria-label="Title"
            pressed={activeFormat === 'DocumentTitle'}
            onClick={() => applyFormatToSelectedRange({ format: { type: 'DocumentTitle' }, setState })}
          />
          <Button
            variant="secondary"
            icon={<SubtitleIcon />}
            iconOnly
            aria-label="Subtitle"
            pressed={activeFormat === 'DocumentSubtitle'}
            onClick={() => applyFormatToSelectedRange({ format: { type: 'DocumentSubtitle' }, setState })}
          />
          <Button
            variant="secondary"
            icon={<LargeSectionTitleIcon />}
            iconOnly
            aria-label="Large Section Title"
            pressed={activeFormat === 'DocumentSectionTitle'}
            onClick={() => applyFormatToSelectedRange({ format: { type: 'DocumentSectionTitle', size: 2 }, setState })}
          />
          <Button
            variant="secondary"
            icon={<SmallSectionTitleIcon />}
            iconOnly
            aria-label="Small Section Title"
            pressed={activeFormat === 'DocumentSectionTitle'}
            onClick={() => applyFormatToSelectedRange({ format: { type: 'DocumentSectionTitle', size: 3 }, setState })}
          />
          <Button
            variant="secondary"
            icon={<EmphasisIcon />}
            iconOnly
            aria-label="Emphasis"
            pressed={activeFormat === 'DocumentEmphasis'}
            onClick={() => applyFormatToSelectedRange({ format: { type: 'DocumentEmphasis' }, setState })}
          />
          <Button
            variant="secondary"
            icon={<SuperscriptIcon />}
            iconOnly
            aria-label="Superscript"
            pressed={activeStyleTypes.includes('sup')}
            onClick={() => applyStyleToSelectedRange({ style: { type: 'sup' }, setState })}
          />
          <Button
            variant="secondary"
            icon={<CitationsSectionIcon />}
            iconOnly
            aria-label="Citations Section"
            pressed={activeFormat === 'DocumentCitationsSection' || activeFormat === 'DocumentCitation'}
            onClick={() => applyFormatToSelectedRange({ format: { type: 'DocumentCitationsSection' }, setState })}
          />
        </div>
      )}
    </>
  );
};

export default EventDescriptionFormattingControls;
